<template>
  <div>
    <div class="notice-top">
      <h2>
        <span>公告</span>
        <em @click="handleClose"></em>
      </h2>
    </div>
    <div class="notice-list">
      <ul>
        <li v-for="t in noticeList"  :key="t.id">
          <h3>{{t.title}}</h3>
          <div v-html="t.content">
            <!-- <p>1.界面全新升级，更好的视觉优化</p>
            <p>2.内容更加完善，新增ui设计</p>
            <p>3.修复若干bug</p>
            <p>4.界面全新升级，更好的视觉优化</p>
            <p>5.内容更加完善，新增ui设计</p>
            <p>6.修复若干bug</p> -->
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: "notice",
    data () {
      return {
        noticeList:[]
      }
    },
    created(){
      // this.getNotice('5003579227','SM-N9600','1');
    },
    methods: {
      // applyNo 应用编号
      // phoneModel机型
      getNotice(applyno,phoneModel,loginpop){
        let that = this;
        this.$ajax({
          url:"coupon-market/notice/h5LoginNotice",
          async:false,
          data:{applyno,phoneModel,loginpop},
          token:window.sessionStorage.getItem('token'),
          success:function(response){
            if (response.code== 0) {
              that.noticeList=response.data;
            }else{
              that.$message.error(response.message);
            }
          },
          error:function(){
            that.$message.error("请求失败");
          }
        })
      },
      handleClose(){
        notice_android.noticeClose();
      }
    },
    mounted () {
      window.InitNotice = this.getNotice;
    },
  }
</script>

<style scoped>
  @import "../../static/css/notice.css"
</style>



// WEBPACK FOOTER //
// src/components/login_notice.vue